import classNames from 'classnames';
import React from 'react';

import styles from './styles/close_button.module.scss';

export const CloseButtonModal = ({ handleClose, ...props }) => {
  const buttonClasses = classNames({
    [styles.close_btn]: true,
  });

  return (
    <button
      className={buttonClasses}
      id="closeBtn-confirmPage"
      onClick={handleClose}
      {...props}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.46 12L19 17.54L18 18.5L17.54 19L12 13.46L6.46 19L5.5 18L5 17.54L10.54 12L5 6.46L6 5.5L6.46 5L12 10.54L17.54 5L18.5 6L19 6.46L13.46 12Z"
          fill="#222222"
        />
      </svg>
    </button>
  );
};
